import { makeStyles } from '@material-ui/core';

export const useCancelPurchaseStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    marginTop: 16,
    color: '#464646',
    textAlign: (props) => (props.mobile ? 'center' : null),
  },
  divider: {
    marginBottom: 16,
    marginTop: 16,
  },
  subtitle: {
    fontSize: 16,
    marginBottom: 16,
    color: '#464646',
    textAlign: (props) => (props.mobile ? 'center' : null),
  },
}));
